document.addEventListener("DOMContentLoaded", () => {
  let allPangoMediaSliderVideos = document.querySelectorAll("[ pango-video-item]");

  allPangoMediaSliderVideos.forEach(item => {
    const label = item.querySelector(".texto-play");
    const video = item.querySelector("video");
    
    if (!label || !video) return;
    
    item.addEventListener("click", () => {

      const isPaused = video.paused; 
      pauseAllVideos(); // <-- ya no altera la lógica posteriormente

      if (isPaused) {
        video.play();
        label.textContent = "PAUSE VIDEO";
      } else {
        video.pause();
        label.textContent = "PLAY VIDEO";
      }
    });
  });

  function pauseAllVideos(){
    console.log("PAUSE ALL VIDEOS")
    allPangoMediaSliderVideos.forEach(item => {
        const label = item.querySelector(".texto-play");
        const video = item.querySelector("video");
        if (video) {
          video.pause();
        } 
        if (label) {
          label.textContent = "PLAY VIDEO";
        }
    });
  }
});
